var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_236_9691)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4187 28.7001C11.0062 29.1126 10.4937 29.4188 9.93123 29.5813L1.92311 31.9376C1.39686 32.0938 0.827486 31.9501 0.439361 31.5063C0.0512234 31.1751 -0.0938891 30.6063 0.0609858 30.0751L2.41686 22.0688C2.58249 21.5063 2.88561 20.9938 3.29999 20.5813L18.9375 4.93945L27.0062 13.0063L11.4187 28.7001Z",
    fill: "#0066FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M22.6688 1.20743C24.2313 -0.354949 26.7687 -0.354949 28.3312 1.20743L30.7938 3.6718C32.3563 5.23368 32.3563 7.76868 30.7938 9.33118L27.0063 13.0062L18.9375 4.9393L22.6688 1.20743Z",
    fill: "#0066FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_236_9691"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.905492134dd4485b0e3ad986b89174d9.svg";
export { ForwardRef as ReactComponent };